export default "__VITE_ASSET__t25fmLi2__"